<template>
  <v-container :class="['topbar', line && 'line']" fluid>
    <!-- <div>
      <a href="https://codewizardshq.com/">&lt;- Back To CodeWizardsHQ</a>
    </div> -->
    <v-img
      :src="$img('blueHorizontal.svg')"
      min-width="100"
      height="60"
      contain
      class="img"
    />
    <!-- <div class="right-wrapper">
      <a href="https://username.codewizardshq.com/edit/">Student Login</a> |
      <a href="https://username.codewizardshq.com/edit/?p">Parent Login</a> |
      <a href="https://codewizardshq.com/students/">Student Center</a>
    </div> -->
  </v-container>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router/composables'

const line = computed(() => useRoute().path.includes('start'))
</script>

<style lang="scss" scoped>
.topbar {
  background-color: #f5f5f5;
  color: rgb(1, 30, 65);
  font-weight: bold;
  padding: 5px 10px;
  line-height: 16px;

  width: 100%;
  z-index: 5;
  margin-top: 10px;
  margin-bottom: 0px;
  display: flex;
  justify-content: space-between;

  a {
    color: rgb(1, 30, 65);
    text-decoration: none;
    font-size: 12px;
    margin: 0 2px;
  }

  @media screen and (max-width: 700px) {
    flex-direction: column;
    .right-wrapper {
      display: none;
    }

    .img {
      margin: 0 auto;
      width: 300px;
    }
  }
}
.line {
  border-bottom: 1px solid #e9e9e9;
  padding-bottom: 16px;
}
</style>
